<div class="copilot-thinking text-muted small" role="status" aria-live="polite">
  <span class="copilot-thinking__dots" aria-hidden="true">
    <span></span><span></span><span></span>
  </span>
  @for (p of [phrase]; track p) {
    <span class="copilot-thinking__text">{{ p | translate }}…</span>
  }
</div>
